import {FilterSet, MenuNode, MenuNodeCfgSet, StaffUtilisationDataSet, Task} from "./types.ts";
import * as React from "react";
import {UtilisationMenuItemHeading} from "./UtilisationMenuItemHeading.tsx";
import {UtilisationCell} from "./UtilisationCell.tsx";
import {VirtualItem, Virtualizer} from "@tanstack/react-virtual";
import * as stream from "stream";
import {COL_WIDTH_BY_INTERVAL} from "./VirtualisedGrid.tsx";
import {Staff} from "../Components/BaseTypes.ts";
import {sumArray} from "../Components/Utils.ts";


interface PropTypes {
    utilisationData: StaffUtilisationDataSet,
    staff: { [staffCallname: string]: Staff[] };
    menuNodeCfgSet: MenuNodeCfgSet,
    setMenuNodeCfgSet: React.Dispatch<React.SetStateAction<MenuNodeCfgSet>>,
    tasks: Record<number, Task>,
    virtualRow: VirtualItem,
    filters: FilterSet,
    columnVirtualizer: Virtualizer<undefined, Element>,
    menuNodesFlatToRender: MenuNode[],
    style?: object,
    isOver?: boolean,
    transform?: stream.internal.Transform,
    HEADING_COL_WIDTH: number,
    showClientTags: boolean
}

export const UtilisationGridRow = React.forwardRef(({
                                                        utilisationData,
                                                        staff,
                                                        menuNodeCfgSet,
                                                        tasks,
                                                        setMenuNodeCfgSet,
                                                        virtualRow,
                                                        menuNodesFlatToRender,
                                                        columnVirtualizer,
                                                        filters,
                                                        isOver,
                                                        transform,
                                                        HEADING_COL_WIDTH,
    showClientTags,
                                                        ...rest
                                                    }: PropTypes, ref) => {
    const menuNode = menuNodesFlatToRender[virtualRow.index - 1];
    // if (menuNode && (!menuNodeCfgSet[menuNode.key] || !('open' in menuNodeCfgSet[menuNode.key]))) menuNodeCfgSet[menuNode.key] = {};
    if (menuNode && !menuNodeCfgSet[menuNode.key]) menuNodeCfgSet[menuNode.key] = {};
    const menuNodeCfg = menuNodeCfgSet[menuNode?.key];
    const staffCallname = menuNode?.staffCallname;

    // const {
    //     attributes,
    //     listeners,
    //     setNodeRef,
    //     transform,
    //     transition,
    // } = (sortable && menuNode ? useSortable({id: dragId}) : {
    //     attributes: {},
    //     listeners: {},
    //     transform: null,
    //     transition: null,
    //     setNodeRef: null
    // });

    // if (sortable) {
    //     console.log(transform);
    // }
    // const style = {
    //     transform: CSS.Transform.toString(transform),
    //     transition,
    // };


    return <React.Fragment>
        {/*<div ref={sortable ? setNodeRef : null} {...attributes} {...listeners} style={style}>*/}
        {/*<div ref={ref} {...rest}>*/}
        <div
            ref={ref}
            // ref={sortable ? setNodeRef : null} {...attributes} {...listeners}
            style={virtualRow.index === 0 ? {
                    position: 'sticky',
                    zIndex: 1,
                    marginBottom: '-23px',
                    top: 0,
                    backgroundColor: 'white',
                }
                : {
                    width: '100%',
                    height: `${virtualRow.size}px`,
                    cursor: 'pointer',
                    position: 'absolute',
                    transform: `translateY(${virtualRow.start + (transform?.y || 0)}px)`,
                    transition: 'transform 200ms ease',
                    // borderTop: isOver ? 'solid black 3px' : null
                }}
            {...rest}
            className={'util_row' + ' ' + (virtualRow.index % 2 ? 'odd' : 'even')}
            onClick={() => {
                if (menuNode.key === 'mel') {
                    menuNodeCfg.open = true;
                    menuNodeCfg.openChildren = !menuNodeCfg.openChildren;
                    menuNode.children.forEach(node => {
                        if (!menuNodeCfgSet[node.key]) menuNodeCfgSet[node.key] = {};
                        menuNodeCfgSet[node.key].open = menuNodeCfg.openChildren;
                    })
                } else {
                    menuNodeCfg.open = !menuNodeCfg.open;
                }
                setMenuNodeCfgSet({...menuNodeCfgSet});
            }}
        >
            {columnVirtualizer.getVirtualItems().map((virtualColumn) => {
                const id = virtualColumn.index - 2;
                const columnDate = utilisationData.dateIndexes[id];
                const row = virtualRow.index;
                const col = virtualColumn.index;
                let cell = null;

                if (row === 0) {
                    switch (col) {
                        case 0:
                            cell = <div className="d-flex">
                                <div style={{width: `${HEADING_COL_WIDTH - 72}px`}}></div>
                                <div style={{width: `68px`, textAlign: 'right'}}>Work</div>
                            </div>
                            break;
                        case 1:
                            cell = filters.overdueTasks && <div style={{width: 68}}>Overdue</div>;
                            break;
                        default:
                            cell = <div style={{
                                borderLeft: 'solid 1px lightgrey',
                                paddingRight: '4px'
                            }}>{`${columnDate.getUTCDate().toString().padStart(2, '0')}/${(columnDate.getUTCMonth() + 1).toString().padStart(2, '0')}`}</div>
                    }
                } else {
                    switch (col) {
                        case 0:
                            cell =
                                <div
                                    className="d-flex" style={{
                                        width: `${HEADING_COL_WIDTH}px`,
                                        backgroundColor: menuNode.errorString ? 'red' : ''
                                }}>
                                    <UtilisationMenuItemHeading key={`${menuNode.key}.tograph`}
                                                                menuNode={menuNode}
                                                                tasks={tasks}
                                                                menuNodeCfgSet={menuNodeCfgSet}
                                                                setMenuNodeCfgSet={setMenuNodeCfgSet}
                                                                HEADING_COL_WIDTH={HEADING_COL_WIDTH}
                                                                showClientTags={showClientTags}
                                    />

                                    <div style={{width: '68px', textAlign: 'right'}}>
                                        {(menuNode.subLevelGroup === 'staff' || menuNode.subLevelGroup === 'group') ?
                                            <UtilisationCell
                                                value={utilisationData[menuNode.rootLevelGroup][menuNode.rootLevelId]?.[menuNode.hoursType]?.total}
                                                showMax={false}
                                                maxValue={100000}/>
                                            : <UtilisationCell
                                                value={sumArray(utilisationData.staff[staffCallname]?.[menuNode.hoursType]?.[menuNode.subLevelGroup]?.[menuNode.id])}
                                                showMax={false}
                                                maxValue={100000}/>
                                        }
                                    </div>
                                </div>
                            break;
                        case 1:
                            if (filters.overdueTasks) {
                                cell =
                                    menuNode.subLevelGroup === 'staff' || menuNode.subLevelGroup === 'group' ?
                                        <UtilisationCell
                                            value={utilisationData[menuNode.rootLevelGroup][menuNode.rootLevelId]?.[menuNode.hoursType]?.overdue?.total}
                                            overDue={true}
                                            showMax={false}
                                            maxValue={0}/>
                                        : <UtilisationCell
                                            overDue={true}
                                            value={utilisationData.staff[staffCallname]?.[menuNode.hoursType]?.overdue?.[menuNode.subLevelGroup]?.[menuNode.id]}
                                            showMax={false}
                                            maxValue={0}/>
                            }
                            break;
                        default:
                            const maxValue =
                                menuNode.rootLevelGroup === 'group' ?
                                    utilisationData.group[menuNode.id]?.periodHours[id]
                                    : filters.interval === 'daily' ?
                                        staff[staffCallname]?.['hoursPerDay'][columnDate.getUTCDay()] * (id in (utilisationData.workDayDates?.[staffCallname] || []) ? utilisationData.workDayDates[staffCallname][id] : 1) :
                                        utilisationData.staff[staffCallname]?.periodHours[id]

                            cell =
                                (
                                    (menuNode.subLevelGroup === 'staff' || menuNode.subLevelGroup === 'group') ?
                                        <UtilisationCell
                                            value={utilisationData[menuNode.rootLevelGroup][menuNode.rootLevelId]?.[menuNode.hoursType]?.['date']?.[id]}
                                            maxValue={maxValue}
                                            // unit={menuNode.hoursType === 'leaveHours' ? 'hours' : menuNode.subLevelGroup === 'group' ? 'percent' : filters.units}
                                            unit={menuNode.hoursType === 'leaveHours' ? 'hours' : menuNode.subLevelGroup === 'group' ? 'percent' : filters.units}
                                            showMax={menuNode.hoursType !== 'leaveHours'}
                                            baseColourOnly={menuNode.hoursType === 'leaveHours'}/>
                                        : <UtilisationCell
                                            unit={menuNode.hoursType === 'leaveHours' ? 'hours' : filters.units}
                                            value={utilisationData.staff[staffCallname]?.[menuNode.hoursType]?.[menuNode.subLevelGroup]?.[menuNode.id]?.[id]}
                                            baseColourOnly={true}
                                            maxValue={maxValue}/>
                                )
                    }
                }

                return (
                    <div
                        key={virtualColumn.key}
                        className={col == 0 ? 'colHeader' : ''}
                        style={col == 0 ? {
                            zIndex: 1,
                            position: 'sticky',
                            top: 0,
                            left: 0,
                            width: `${virtualColumn.size}px`,
                            height: `${virtualRow.size}px`,
                        } : {
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            textAlign: 'right',
                            width: col === 1 ? 68 : `${virtualColumn.size}px`,
                            height: `${virtualRow.size}px`,
                            transform: `translateX(${virtualColumn.start}px)`,
                        }}
                    >
                        {cell}
                    </div>
                )
            })}
        </div>
        {/*</div>*/}
    </React.Fragment>
});